// Joins string parts into the single value the server stores. A missing part is skipped so it
// never ends up in the result as the text "undefined".
const joinParts = (...parts: (string | null | undefined)[]): string | undefined => {
    const joined = parts.filter(Boolean).join('');
    return joined || undefined;
};

export default joinParts;
